var map = {
	"./bikes-customisation.jpg": 8580,
	"./bikes-models.jpg": 9792,
	"./club.jpg": 6333,
	"./contact.jpg": 897,
	"./hero.jpg": 7641,
	"./oduwan.jpg": 3785,
	"./process.jpg": 6366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6575;